import React, { useState, useEffect } from 'react';
import TargetConnectionService from '../../services/TargetConnectionService';
import Swal from 'sweetalert2';

const TargetConnectionList = () => {
  const [targetConnection, setTargetConnection] = useState({});
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    host: '',
    port: '',
    username: '',
    password: '',
  });

  useEffect(() => {
    fetchTargetConnection();
  }, []);

  const fetchTargetConnection = async () => {
    setLoading(true);
    try {
      const data = await TargetConnectionService.get();
      setTargetConnection(data);
      setFormData({
        host: data.host || '',
        port: data.port || '',
        username: data.username || '',
        password: data.password || '',
      });
    } catch (error) {
      Swal.fire('Error', 'Failed to fetch target connection', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      if (targetConnection?.id) {
        await TargetConnectionService.update(formData);
        Swal.fire('Updated', 'Target connection updated successfully', 'success');
      } else {
        await TargetConnectionService.create(formData);
        Swal.fire('Created', 'Target connection created successfully', 'success');
      }
      fetchTargetConnection();
    } catch (error) {
      Swal.fire('Error', 'Failed to save target connection', 'error');
    }
  };

  const handleDelete = async () => {
    try {
      await TargetConnectionService.delete(targetConnection.id);
      Swal.fire('Deleted', 'Target connection deleted successfully', 'success');
      setTargetConnection({});
      setFormData({
        host: '',
        port: '',
        username: '',
        password: '',
      });
    } catch (error) {
      Swal.fire('Error', 'Failed to delete target connection', 'error');
    }
  };

  if (loading) {
    return <p>Loading...</p>;
  }

  return (
    <div className="content-wrapper">
      <div className="row">
        <div className="col-md-8 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Target Connection</h4>
              <form onSubmit={handleSave}>
                <div className="form-group">
                  <label>Host</label>
                  <input
                    type="text"
                    className="form-control"
                    name="host"
                    value={formData.host}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Port</label>
                  <input
                    type="number"
                    className="form-control"
                    name="port"
                    value={formData.port}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Username</label>
                  <input
                    type="text"
                    className="form-control"
                    name="username"
                    value={formData.username}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Password</label>
                  <input
                    type="password"
                    className="form-control"
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <button type="submit" className="btn btn-primary mr-2">
                  Save
                </button>
                {targetConnection?.id && (
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={handleDelete}
                  >
                    Delete
                  </button>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TargetConnectionList;
